import { BikeDataLadderSearchService } from '../../../epics/fields/bikeData';
import {
    getBikeBodyTypeKey,
    getBikeMarkKey,
    getBikeModelKey,
    getBikeModificationKey,
    getBikeTypeKey,
} from './bikeKeys';
import { createCachedServiceThunk } from '../../thunkFactory';

export const getBikeType = createCachedServiceThunk(
    getBikeTypeKey,
    () => BikeDataLadderSearchService.getBikeType(),
);

export const getBikeMark = createCachedServiceThunk(
    getBikeMarkKey,
    (params) =>
        BikeDataLadderSearchService.getBikeMark(params?.type || params),
);

export const getBikeModel = createCachedServiceThunk(
    getBikeModelKey,
    (params) => BikeDataLadderSearchService.getBikeModel(params),
);

export const getBikeBodyType = createCachedServiceThunk(
    getBikeBodyTypeKey,
    (params) => BikeDataLadderSearchService.getBikeBodyType(params),
);

export const getBikeCharacteristic = createCachedServiceThunk(
    getBikeBodyTypeKey,
    (payload) => BikeDataLadderSearchService.getBikeCharacteristic(payload),
);

export const getBikeTechData = createCachedServiceThunk(
    getBikeCharacteristic,
    (params) => BikeDataLadderSearchService.getBikeTechData(params),
);

export const getBikeModification = createCachedServiceThunk(
    getBikeModificationKey,
    (params) => BikeDataLadderSearchService.getBikeModification(params),
);
